<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header pb-0">
            <div class="d-flex justify-content-between align-items-center mb-2 flex-wrap gap-2">
              <h6 class="mb-0">Insumos</h6>
              <button type="button" class="btn btn-primary btn-sm" @click="openCreate">
                Agregar <i class="fa fa-plus ms-1"></i>
              </button>
            </div>
            <div class="row align-items-end">
              <div class="col-md-4 mb-3">
                <label for="supplySearch" class="mb-1">Buscar</label>
                <input
                  type="text"
                  v-model="search"
                  id="supplySearch"
                  class="form-control"
                  placeholder="Buscar por nombre o código..."
                  @input="onSearchInput"
                />
              </div>
            </div>
          </div>

          <div class="card-body px-0 pt-0 pb-2">
            <div v-if="loading" class="text-center py-5">
              <i class="fas fa-spinner fa-spin fa-2x text-success"></i>
              <p class="mt-2 text-sm text-secondary">Cargando insumos...</p>
            </div>

            <div v-else class="table-responsive p-0">
              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Nombre</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Código</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Unidad</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Descripción</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Estado</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="supplies.length === 0">
                    <td colspan="6" class="text-center text-secondary text-sm py-4">
                      No hay insumos registrados.
                    </td>
                  </tr>
                  <tr v-for="supply in supplies" :key="supply.id">
                    <td class="align-middle">
                      <h6 class="mb-0 text-sm">{{ supply.name }}</h6>
                    </td>
                    <td class="align-middle">
                      <span class="text-xs text-secondary">{{ supply.code || '—' }}</span>
                    </td>
                    <td class="align-middle">
                      <span class="text-xs text-secondary">{{ supply.unit || '—' }}</span>
                    </td>
                    <td class="align-middle">
                      <span class="text-xs text-secondary text-truncate d-inline-block" style="max-width: 260px;" :title="supply.description">
                        {{ supply.description || '—' }}
                      </span>
                    </td>
                    <td class="text-center align-middle">
                      <span class="badge badge-sm" :class="supply.status ? 'bg-success' : 'bg-secondary'">
                        {{ supply.status ? 'Activo' : 'Inactivo' }}
                      </span>
                    </td>
                    <td class="text-center align-middle">
                      <button
                        type="button"
                        class="btn btn-link text-secondary mb-0 p-1"
                        title="Editar"
                        @click="openEdit(supply)"
                      >
                        <i class="fas fa-pencil-alt text-xs"></i>
                      </button>
                      <button
                        type="button"
                        class="btn btn-link text-danger mb-0 p-1"
                        title="Eliminar"
                        :disabled="deletingId === supply.id"
                        @click="deleteSupply(supply)"
                      >
                        <i class="fas fa-trash text-xs"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div v-if="!loading && lastPage > 1" class="d-flex justify-content-end align-items-center gap-2 px-4 py-3">
              <button
                type="button"
                class="btn btn-outline-secondary btn-sm mb-0"
                :disabled="currentPage <= 1"
                @click="changePage(currentPage - 1)"
              >
                Anterior
              </button>
              <span class="text-xs text-secondary">Página {{ currentPage }} de {{ lastPage }}</span>
              <button
                type="button"
                class="btn btn-outline-secondary btn-sm mb-0"
                :disabled="currentPage >= lastPage"
                @click="changePage(currentPage + 1)"
              >
                Siguiente
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal crear / editar insumo -->
    <div v-if="showModal" class="picking-modal-overlay" @click.self="showModal = false">
      <div class="picking-modal-box card shadow" style="max-width: 520px;">
        <div class="card-body">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <h6 class="mb-0">{{ form.id ? 'Editar insumo' : 'Nuevo insumo' }}</h6>
            <button type="button" class="btn-close" @click="showModal = false"></button>
          </div>

          <div class="row">
            <div class="col-md-8">
              <label for="supplyName" class="form-control-label">Nombre *</label>
              <input id="supplyName" type="text" class="form-control" v-model="form.name" placeholder="Ej: Suela, Hilo, Caja..." />
            </div>
            <div class="col-md-4">
              <label for="supplyCode" class="form-control-label">Código</label>
              <input id="supplyCode" type="text" class="form-control" v-model="form.code" placeholder="Opcional" />
            </div>
            <div class="col-md-4 mt-3">
              <label for="supplyUnit" class="form-control-label">Unidad</label>
              <input id="supplyUnit" type="text" class="form-control" v-model="form.unit" placeholder="und, m, kg, rollo..." />
            </div>
            <div class="col-md-8 mt-3">
              <label for="supplyStatus" class="form-control-label">Estado</label>
              <select id="supplyStatus" class="form-select" v-model="form.status">
                <option :value="true">Activo</option>
                <option :value="false">Inactivo</option>
              </select>
            </div>
            <div class="col-12 mt-3">
              <label for="supplyDescription" class="form-control-label">Descripción</label>
              <textarea id="supplyDescription" class="form-control" rows="2" v-model="form.description" placeholder="Opcional"></textarea>
            </div>
          </div>

          <div class="d-flex justify-content-end gap-2 mt-4">
            <button type="button" class="btn btn-secondary btn-sm" @click="showModal = false">
              <i class="fas fa-times me-1"></i> Cancelar
            </button>
            <button type="button" class="btn btn-success btn-sm" :disabled="saving" @click="save">
              <i class="fas" :class="saving ? 'fa-spinner fa-spin' : 'fa-check'"></i> Guardar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from 'sweetalert2';
import suppliesService from '@/services/supplies.service';

export default {
  name: 'Insumos',
  data() {
    return {
      supplies: [],
      loading: true,
      search: '',
      currentPage: 1,
      lastPage: 1,
      showModal: false,
      saving: false,
      deletingId: null,
      form: {},
    };
  },
  methods: {
    async fetchSupplies() {
      this.loading = true;
      try {
        const params = { page: this.currentPage, per_page: 10 };
        if (this.search.trim()) {
          params.search = this.search.trim();
        }
        const res = await suppliesService.getAll(params);
        this.supplies = res.data.data || [];
        this.currentPage = res.data.current_page || 1;
        this.lastPage = res.data.last_page || 1;
      } catch (error) {
        console.error('Error al cargar insumos:', error);
        await Swal.fire('Error', 'No se pudieron cargar los insumos', 'error');
      } finally {
        this.loading = false;
      }
    },
    onSearchInput() {
      clearTimeout(this._searchTimer);
      this._searchTimer = setTimeout(() => {
        this.currentPage = 1;
        this.fetchSupplies();
      }, 300);
    },
    changePage(page) {
      this.currentPage = page;
      this.fetchSupplies();
    },
    openCreate() {
      this.form = { name: '', code: '', unit: 'und', description: '', status: true };
      this.showModal = true;
    },
    openEdit(supply) {
      this.form = {
        id: supply.id,
        name: supply.name,
        code: supply.code || '',
        unit: supply.unit || '',
        description: supply.description || '',
        status: !!supply.status,
      };
      this.showModal = true;
    },
    async save() {
      if (!this.form.name || !this.form.name.trim()) {
        await Swal.fire('Atención', 'El nombre es obligatorio', 'warning');
        return;
      }
      this.saving = true;
      try {
        if (this.form.id) {
          await suppliesService.updateData(this.form.id, this.form);
        } else {
          await suppliesService.createData(this.form);
        }
        this.showModal = false;
        await Swal.fire({
          icon: 'success',
          title: 'Insumo guardado',
          timer: 1200,
          showConfirmButton: false,
        });
        await this.fetchSupplies();
      } catch (error) {
        console.error('Error al guardar insumo:', error);
        const msg = error.response?.data?.message || Object.values(error.response?.data?.errors || {})[0]?.[0] || 'No se pudo guardar el insumo';
        await Swal.fire('Error', msg, 'error');
      } finally {
        this.saving = false;
      }
    },
    async deleteSupply(supply) {
      const result = await Swal.fire({
        title: 'Eliminar insumo',
        text: `¿Eliminar el insumo "${supply.name}"? Dejará de aparecer en las listas de materiales de los productos.`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#e91e63',
        cancelButtonColor: '#6c757d',
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'Cancelar',
      });
      if (!result.isConfirmed) return;

      this.deletingId = supply.id;
      try {
        await suppliesService.deleteData(supply.id);
        await Swal.fire({ icon: 'success', title: 'Insumo eliminado', timer: 1200, showConfirmButton: false });
        await this.fetchSupplies();
      } catch (error) {
        console.error('Error al eliminar insumo:', error);
        await Swal.fire('Error', 'No se pudo eliminar el insumo', 'error');
      } finally {
        this.deletingId = null;
      }
    },
  },
  mounted() {
    this.fetchSupplies();
  },
};
</script>

<style scoped>
.picking-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.picking-modal-box {
  width: 600px;
  max-width: 95vw;
  max-height: 85vh;
  overflow-y: auto;
}
</style>
